/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeroBannerSlideData } from './hero-banner-slide.data';
import { IHeroBannerSlideProps } from './hero-banner-slide.props.autogenerated';

export interface IHeroBannerSlideViewProps extends IHeroBannerSlideProps<IHeroBannerSlideData> {}

/**
 *
 * HeroBannerSlide component
 * @extends {React.PureComponent<IHeroBannerSlideProps<IHeroBannerSlideData>>}
 */
class HeroBannerSlide extends React.PureComponent<IHeroBannerSlideProps<IHeroBannerSlideData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HeroBannerSlide;
